<template>
  <regular-bar :config="config">
    <router-link class="button" :to="editPage">
      <v-icon>mdi-pencil-box-outline</v-icon>
    </router-link>
    <div class="button" @click="showDeletePanel">
      <v-icon>mdi-delete</v-icon>
      <v-dialog v-model="showDialog" max-width="500">
        <v-card>
          <v-card-title class="headline error" primary-title="primary-title">
            <h4 class="white--text">{{ $t('deleteBike.title') }}</h4>
          </v-card-title>
          <div class="card-content pl-5 pr-5 mb-10">
            <div class="text-center pt-10 pb-10">
              <v-icon color="error" size="50">mdi-alert</v-icon>
            </div>
            <p class="text-center font-weight-medium is-size-5" v-html="warningOfDelete"></p>
          </div>
          <v-card-actions>
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="auto">
                <v-btn class="mr-5" @click="cancel" color="error" outlined="outlined" min-width="180">{{ $t('buttons.cancel') }}</v-btn>
                <v-btn @click="deleteBikes" color="error" min-width="180">{{ $t('buttons.confirm') }}</v-btn>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </regular-bar>
</template>

<script>
import QueryMode from '@/mixins/QueryMode'
import RegularBar from './Regular'

export default {
  mixins: [QueryMode],
  components: { RegularBar },
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      showDialog: false
    }
  },
  computed: {
    warningOfDelete () {
      return this.$t('deleteBike.singleDelete')
    },
    editPage () {
      return this.$route.path + '/edit'
    }
  },
  methods: {
    showDeletePanel () {
      this.showDialog = true
    },
    deleteBikes () {
      // do action
      this.showDialog = false
      this.$router.push('/bikes')
    },
    cancel () {
      this.showDialog = false
    }
  }
}
</script>
